import { put, all, race, take } from 'redux-saga/effects'
import { Map } from 'immutable'
import { SUCCESS, FAILED } from 'crom-api-constants'

import { reportEntityUpdate } from '../../scenes/Gnosus/scenes/Report/actions'

import { FSTMT_GET_RESULTS_DATA_REQUEST } from './constants'

import { fstmtGetResultsDataRequest } from './actions'

const FSTMT_GET_RESULTS_DATA_REQUEST_SUCCESS = (module, entId) =>
    `${FSTMT_GET_RESULTS_DATA_REQUEST(module, entId)}_${SUCCESS}`
const FSTMT_GET_RESULTS_DATA_REQUEST_FAILED = (module, entId) =>
    `${FSTMT_GET_RESULTS_DATA_REQUEST(module, entId)}_${FAILED}`

/**
 * Helper function to set block loading true
 * @param {string} module Module key
 * @param {string} blockKey Block key
 * @param {string} id Entity ID
 */
export function* setBlockLoadingTrue(module, blockKey, id) {
    const updates = Map({ blocks: Map({ [blockKey]: Map({ isLoading: true }) }) })

    yield put(reportEntityUpdate(id, updates))
}

/**
 * Helper function to set block loading false
 * @param {string} module Module key
 * @param {string} blockKey Block key
 * @param {string} id Entity ID
 */
export function* setBlockLoadingFalse(module, blockKey, id) {
    const updates = Map({ blocks: Map({ [blockKey]: Map({ isLoading: false }) }) })

    yield put(reportEntityUpdate(id, updates))
}

export function* getResultsData(module, id, blockKey, lang, token, level, standardType) {
    return yield all({
        response: race({
            success: take(FSTMT_GET_RESULTS_DATA_REQUEST_SUCCESS(module, id)),
            failed: take(FSTMT_GET_RESULTS_DATA_REQUEST_FAILED(module, id)),
        }),
        request: put(
            fstmtGetResultsDataRequest(module, blockKey, id, {
                'standards[]': [standardType],
                lang,
                token,
                level,
            })
        ),
    })
}
